import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PlusIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 14.002}
      height={height || 14.002}
      viewBox="0 0 14.002 14.002"
    >
      <path
        d="M1814 237v-5h-5a1 1 0 01-1-1 1 1 0 011-1h5v-5a1 1 0 011-1 1 1 0 011 1v5h5a1 1 0 011 1 1 1 0 01-1 1h-5v5a1 1 0 01-1 1 1 1 0 01-1-1z"
        fill={color || "#fb972e"}
        transform="translate(-1807.999 -224.001)"
      />
    </svg>
  );
}
